import { ROULETTE_FETCH_WIN_LOSS_REPORT } from "./constant";

const init = {
    winloseReport: {
        tickets: [],
        summary: {
            totalBetAmount: 0,
            totalWinAmount: "",
            totalWinLoseAmount: "",
            currencyCode: "",
        },
        page: 0,
        size: 0,
        totals: 0,
    },
};

export default (state = init, { type, payload }) => {
    switch (type) {
        case ROULETTE_FETCH_WIN_LOSS_REPORT:
            return {
                ...state,
                winloseReport: {
                    ...state.winloseReport,
                    ...payload,
                },
            };
        default:
            return state;
    }
};